const state = {
  scroll: 0,
  fromid: -1,
};
const mutations = {
  scroll(state, scroll) {
    state.scroll = scroll;
  },
  fromid(state, fromid) {
    state.fromid = fromid;
  },
};
const actions = {
  scroll: ({ commit }) => commit("scroll"),
  fromid: ({ commit }) => commit("fromid"),
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
